







import { Component, Vue } from 'vue-property-decorator';
import ConfirmEmail from '@/components/auth/ConfirmEmail.vue';

@Component({
  components: {
    ConfirmEmail,
  },
})
export default class ConfirmEmailScreen extends Vue { }
